import _ from 'lodash'

export const CachedArray = {
  beforeDestroy() {
    this.resetCachedArray()
  },

  data() {
    return {
      cachedArray: [],
    }
  },

  methods: {
    pushToCachedArray(array) {
      if (_.get(array, '[0]')) {
        this.cachedArray = _.unionBy(this.cachedArray, array, value => value.id)
      }
    },

    unshiftCachedArray(array) {
      if (_.get(array, '[0]')) {
        this.cachedArray = _.unionBy(this.cachedArray, array, value => value.id)
      }
    },

    resetCachedArray(seed) {
      this.cachedArray = _.get(seed, '[0]') ? seed : []
    },
  },
}

export default { CachedArray }
